export default function decode(text: string) {
    if (process.env.ENV_NODE) {
        return require('he').decode(text);
    }

    const div = document.createElement('div');
    div.innerHTML = text;
    return div.textContent || div.innerText || '';
}
